import { createContext } from 'react'

const ThirdPartyManagementStepperContext = createContext()

export default ThirdPartyManagementStepperContext
